import {Button, ButtonGroup, Choice, closeDialog} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useState} from 'react';

import {useGetManufacturersQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {getOptionsFromManufacturers} from '@dms/shared';

import {pushGtmEvent} from 'shared/web';

interface BulkAssignManufacturerProps {
  dialogId: string;
  onAssign: (manufacturerId: string) => void;
}

export function BulkAssignManufacturer(props: BulkAssignManufacturerProps) {
  const [manufacturerId, setManufacturerId] = useState<string | null>(null);

  const manufacturersQuery = useGetManufacturersQuery();

  const handleDiscard = () => {
    pushGtmEvent({
      event: 'button_click',
      event_id: 'ai_tool_dn_bulk_assign_manufacturer_discard',
    });
    closeDialog(props.dialogId);
  };

  const handleAssign = () => {
    if (!manufacturerId) {
      return;
    }
    pushGtmEvent({
      event: 'button_click',
      event_id: 'ai_tool_dn_bulk_assign_manufacturer',
    });
    props.onAssign(manufacturerId);
    closeDialog(props.dialogId);
  };

  return (
    <VStack spacing={4}>
      <Choice
        isRequired
        isLoading={manufacturersQuery.isLoading}
        isNotClearable
        value={manufacturerId}
        onChange={setManufacturerId}
        options={getOptionsFromManufacturers(manufacturersQuery.data)}
        label={i18n.t('entity.warehouse.labels.manufacturer')}
        menuInPortal
      />
      <ButtonGroup align="right">
        <Button
          title={i18n.t('general.actions.discard')}
          variant="secondary"
          onClick={handleDiscard}
        />
        <Button
          isDisabled={!manufacturerId}
          title={i18n.t('general.actions.assign')}
          variant="primary"
          onClick={handleAssign}
        />
      </ButtonGroup>
    </VStack>
  );
}
